import type { UserState, Countries, Langs } from '@/redux/user/types';
import { MCD } from '@/services/app';
import Store from '@/redux';

import {
  setUserData,
  setUserPoints,
  setUserCountry,
  setUserLanguage
} from '@/redux/user/actions';

export const checkUserData = async () => {
  try {
    const userData = (await MCD.getUserData()) as UserState;
    console.info('User Data:', userData);
    Store.dispatch(setUserData(userData));
  } catch (error) {
    console.error('"checkUserData" error:', error);
    throw error;
  }
};

export const checkUserPoints = async () => {
  try {
    const userPoints = await MCD.getUserPoints();
    console.info('User Points:', userPoints);
    Store.dispatch(setUserPoints(userPoints));
  } catch (error) {
    console.error('"checkUserPoints" error:', error);
    throw error;
  }
};

export const checkUserCountry = async () => {
  try {
    const userCountry = (
      await MCD.getUserCountry()
    ).toLocaleLowerCase() as Countries;

    console.info('User Country:', userCountry);
    Store.dispatch(setUserCountry(userCountry));
  } catch (error) {
    console.error('"checkUserCountry" error:', error);
    throw error;
  }
};

export const checkUserLanguage = async () => {
  try {
    const userLanguage = (
      await MCD.getUserLanguage()
    ).toLocaleLowerCase() as Langs;

    const countrySeparator = userLanguage.indexOf('-');
    const end = countrySeparator > -1 && countrySeparator;
    const language = userLanguage.slice(0, end || undefined);

    console.info('User Language:', language);
    Store.dispatch(setUserLanguage(language));
  } catch (error) {
    console.error('"checkUserLanguage" error:', error);
    throw error;
  }
};
